module.exports = __webpack_public_path__ + "static/media/Swirepay_us_logo.0c4a171a.svg";